// extracted by mini-css-extract-plugin
export default {"wrapper":"CaptureVisa_style_wrapper__pMNEk","rotate":"CaptureVisa_style_rotate__m9DoM"};